<div class="table-responsive mt-4">
  <table class="table table-sm align-middle">
    <thead>
      <tr>
        <th>Data</th>
        <th>Dia</th>
        <th>Matricula</th>
        <th>Funcionario</th>
        <th>Batidas realizadas</th>
        <th>Batidas faltantes</th>
        <th class="text-center">Qtd.</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let linha of linhas">
        <td>{{ linha.data }}</td>
        <td class="fw-semibold">{{ linha.diaSemana }}</td>
        <td>{{ linha.matricula }}</td>
        <td>{{ linha.nome }}</td>
        <td>
          <span *ngFor="let batida of linha.batidas.slice(0, linha.batidasEsperadas); let ultimo = last">
            {{ batida || '-' }}<span *ngIf="!ultimo"> | </span>
          </span>
        </td>
        <td>
          <span class="badge text-bg-danger me-1" *ngFor="let falta of linha.batidasFaltantes">{{ falta }}</span>
        </td>
        <td class="text-center fw-semibold">{{ linha.batidasFaltantes.length }}</td>
      </tr>
      <tr *ngIf="pesquisado && linhas.length === 0">
        <td colspan="7" class="text-secondary">Nenhuma batida faltante encontrada no periodo.</td>
      </tr>
      <tr *ngIf="!pesquisado">
        <td colspan="7" class="text-secondary">Informe os filtros e clique em pesquisar.</td>
      </tr>
    </tbody>
  </table>
</div>
